import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ResetPassword } from '../../../shared/models/rest-password.model';
import { PasswordRecoveryRepository } from '../repositories/password-recovery.repository';

@Injectable()
export class PasswordRecoveryService {
  constructor(private passwordRepository: PasswordRecoveryRepository) {}
  recoverPassword(username: string): Observable<any> {
    return this.passwordRepository.recoverPassword(username);
  }

  resetPassword(username: string, resetToken: string, passwords: ResetPassword) {
    return this.passwordRepository.resetPassword(username, resetToken, passwords);
  }

  checkResetTokenValid(username: string, token: string): Observable<any> {
    return this.passwordRepository.checkResetTokenValid(username, token);
  }
}
